
export class MdbSelectOptions{
    value: number;
    label: string;
  }